<script setup lang="ts">
  import { watchDebounced } from '@vueuse/core'
  import { LoaderCircleIcon, Search } from 'lucide-vue-next'

  const modelValue = defineModel<string>({ default: '' })

  defineProps<{
    label?: string,
    placeholder?: string,
    loading?: boolean,
  }>()

  const emit = defineEmits<{
    (e: 'submit', value: string): void,
  }>()

  watchDebounced(
    modelValue,
    () => {
      emit('submit', modelValue.value)
    },
    { debounce: 500 },
  )
</script>

<template>
  <app-input
    v-model="modelValue"
    :label="label"
    :icon="true"
    type="search"
    :placeholder="placeholder ?? 'Cari...'"
    @keyup.enter="emit('submit', modelValue)">
    <template #inline>
      <div class="flex items-center justify-center absolute z-10 w-9 text-sm text-gray">
        <search
          class="size-4 text-gray-500" />
      </div>
      <div class="absolute inset-y-0 right-2 z-10 flex items-center text-xs text-gray">
        <div
          v-if="loading"
          class="flex items-center justify-center h-6 w-6">
          <loader-circle-icon class="size-4 animate-spin text-primary" />
        </div>
      </div>
    </template>
  </app-input>
</template>

<style lang="postcss" scoped>
  :deep() input {
    @apply pl-9 pr-8 placeholder-shown:pr-4;
  }
</style>
